import { isNullish } from 'remeda';
import { CustomAttributeFieldConfig } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { NumberEditor } from './number-edit';
import { NumberView } from './number-view';

export const NUMBER_FIELD_CONFIG: CustomAttributeFieldConfig = {
  type: 'number',
  editable: true,
  View: NumberView,
  Editor: NumberEditor,
  decode: (raw) => {
    // a stored value is a json number, but an authored default arrives as a string, so coerce a
    // numeric string too. empty or non numeric stays null so the cell renders blank.
    const value = typeof raw === 'string' && raw.trim() !== '' ? Number(raw) : raw;
    return { kind: 'number', value: Number.isFinite(value) ? (value as number) : null };
  },
  encode: (value) => getKindLikeValueSafely(value, 'number'),
  isEmpty: (value) => isNullish(getKindLikeValueSafely(value, 'number')),
};
